import { render, staticRenderFns } from "./TenantContacts.vue?vue&type=template&id=f2c61694&scoped=true"
import script from "./TenantContacts.vue?vue&type=script&lang=js"
export * from "./TenantContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c61694",
  null
  
)

export default component.exports